import React from 'react';
import { getEditorConfigValue } from 'components/property-editors/utils/EditorConfigurationUtils';
import { IEditorProps } from './Editor';
import { useEditorId } from './hooks/useEditorId';
import { EditorLabel } from './EditorLabel';
import './ReadOnlyEditor.less';

export function ReadOnlyEditor({ id, child, path }: IEditorProps) {
  [id] = useEditorId(path, id);
  const readOnlyValue = getEditorConfigValue(child, 'readOnlyValue');
  const isArray = Array.isArray(readOnlyValue);
  return (
    <EditorLabel editor={child} path={path} htmlFor={id}>
      {readOnlyValue && isArray ? (
        <textarea
          value={readOnlyValue.join('\n')}
          readOnly={true}
          className="dp-readonly-editor-multiline"
          rows={readOnlyValue.length <= 10 ? readOnlyValue.length : 10} //Maximum visible rows will be 10 after that scrollbar will appear
        />
      ) : (
        <div className="dp-readonly-editor">{readOnlyValue}</div>
      )}
    </EditorLabel>
  );
}
